import React from 'react';
import HomeTwoSingleService from '../../../components/HomeTwoSingleService/HomeTwoSingleService';

const HomeTwoServicesArea = () => {
  return (
    <>
      <section className="servcies-area gray-bg pt-100 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-xl-4 offset-xl-4 col-lg-10 offset-lg-1">
              <div className="section-title text-center pos-rel mb-75">
                <div className="section-icon">
                  <img className="section-back-icon" src="img/section/section-back-icon.png" alt="" />
                </div>
                <div className="section-text pos-rel">
                  <h5>Services</h5>
                  <h2>Our Services</h2>
                </div>
                <div className="section-line pos-rel">
                  <img src="img/shape/section-title-line.png" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <HomeTwoSingleService
              icon="3"
              number="1"
              title="Fill out a form"
              description={
                <p>
                  Request a form to be filled out by a healthcare provider for school, work, disability, insurance or other purposes. In many cases, this can be done without coming to our medical
                  clinic in person. Fees are for reviewing your medical records and vary based on the type of form and the number of pages to fill out.
                </p>
              }
              actionText="Fill out a form"
              actionLink="/medicalform"
            />

            <HomeTwoSingleService
              icon="3"
              number="2"
              title="Sick Notes"
              description={
                <p>
                  Obtain a sick note using telemedicine.
                  <br />
                  Sick notes provided for time off from work or school.
                  <br />
                  You will obtain your sick note through email after paying a fee online.
                  <br />
                  <br />
                  <br />
                  <br />
                </p>
              }
              actionText="Request Sick Note"
              actionLink="/sicknote"
            />

            <HomeTwoSingleService
              icon="2"
              number="3"
              title="Lab and Radiology Testing"
              description={
                <p>
                  Obtain basic lab and radiology testing using telemedicine. You will obtain your lab or radiology requisition through email. <br></br>You will be able to follow up at our clinic or by
                  phone to discuss your lab results with a doctor. Only if 19-years-old or older.
                </p>
              }
              actionText="Request Lab or Radiology Test"
            />
            <HomeTwoSingleService
              icon="1"
              number="4"
              title="Medication Refill"
              description={
                <p>
                  For simple online prescription refills. <br />
                  Not for stimulants (ADHD medications), opiates (pain pills) or benzodiazepines (sleeping pills).
                  <br />
                  Only if 19-year-old or older.
                  <br />
                  <br /> <br />
                </p>
              }
              actionText="Refill Now"
            />
            <HomeTwoSingleService
              icon="4"
              number="5"
              title="Driver's Medical Exam"
              description={
                <p>
                  To assess the medical fitness of drivers as required by RoadSafetyBC.
                  <br />
                  Driver's medical examinations are performed in person at the medical clinic.
                  <br />
                  You will need to bring a form provided by ICBC for the doctor to fill out.
                  <br />
                  Limited time special online price $150.00.
                </p>
              }
              actionText="Book Now"
            />
            <HomeTwoSingleService
              icon="4"
              number="6"
              title="Immigration Medical Exam"
              description={
                <p>
                  For Australia, and New Zealand immigration purposes.
                  <br />
                  Book directly on our website.
                  <br />
                  Fast and efficient services. <br />
                  <br />
                </p>
              }
              actionLink="/immi"
              actionText="Book Immigration Medical Examination"
            />
            <HomeTwoSingleService
              icon="4"
              number="7"
              title="In Person or Telephone Doctor Appointment"
              description={
                <p>
                  Come to see a healthcare provider at the medical clinic or one of our providers will call you.
                  <br></br>Free with a valid B.C. Services Card.
                  <br></br>$5 booking fee for other provinces except Quebec.
                  <br></br>$250 For tourists, visitors, international students, foreign workers, Quebec residents and without a valid B.C. Services Card or equivalent Canadian health card.
                  <br />
                </p>
              }
              actionText="Book Now"
            />
            <HomeTwoSingleService
              icon="4"
              number="8"
              title="Motor Vehicle Crash Appointment"
              description={
                <p>
                  Book only if your motor vehicle crash is covered by ICBC.
                  <br />
                  Either in person at the clinic or the doctor calls you.
                  <br />
                  You will need an ICBC claim number.
                </p>
              }
              actionText="Book Now"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeTwoServicesArea;
